<template>
  <SfModal
    v-if="modalOpen"
    :class="modalClass"
    data-walkthrough-id="restore-default-modal"
    @close="close"
  >
    <template #title>{{
      I18n.t('js.live_inputs.revert_modal.title')
    }}</template>

    <template #messages>
      <SfModalMessage variant="warning">
        {{ I18n.t('js.live_inputs.revert_modal.message') }}
      </SfModalMessage>
    </template>

    <template #body>
      <div class="sf-grid">
        <div class="sf-row">
          <div class="sf-col sf-pad-h-3">
            <div class="sf-c-text sf-pre-wrap">{{ shownDefault }}</div>
            <span class="sf-c-text-light sf-font-xs">{{
              I18n.t('js.live_inputs.revert_modal.label')
            }}</span>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="sf-btn sf-btn-warning sf-level-item" @click.prevent="save">
        {{ I18n.t('js.live_inputs.revert_modal.title') }}
      </div>
      <div class="sf-btn sf-level-item" @click.prevent="close">
        {{ I18n.t('common.form.cancel') }}
      </div>
    </template>
  </SfModal>
</template>

<script>
import { SfModal, SfModalMessage } from '@app/shared/vue/components/sf-modal'

export default {
  components: {
    SfModal,
    SfModalMessage,
  },

  data() {
    return {
      modalOpen: false,

      saveCallback: () => {},
      cancelCallback: () => {},
      defaultValue: null,
      isInput: false,
    }
  },

  computed: {
    modalClass() {
      return `sf-modal-${this.isInput ? 'xs' : 'm'}`
    },

    // A missing default shows nothing, never "NaN".
    shownDefault() {
      const value = this.defaultValue
      return value === null || value === undefined || Number.isNaN(value)
        ? ''
        : value
    },
  },

  // A teardown that unmounts the modal still answers, or the caller hangs.
  beforeUnmount() {
    this.close()
  },

  methods: {
    openModal(data) {
      // A caller still waits on an open modal. It gets its refusal before the
      // new callbacks replace its own.
      this.close()
      this.isInput = data.isInput
      this.defaultValue = data.defaultValue
      this.saveCallback = data.saveCallback
      this.cancelCallback = data.cancelCallback ?? (() => {})
      this.modalOpen = true
    },

    close() {
      this.answer(this.cancelCallback)
    },

    save() {
      this.answer(this.saveCallback)
    },

    // Answers once. A caller that waits on the answer has no deadline.
    answer(callback) {
      if (!this.modalOpen) return

      this.modalOpen = false
      callback()
    },
  },
}
</script>
